import * as React from 'react';
import AppLayoutContextUpdater from '../Common/AppLayoutContextUpdater/AppLayoutContextUpdater';

const confirmationText =
  'Thank you! We have received your Loan Estimate request and we will provide your Loan Estimate within 3 business days.';

class LoanEstimateReceived extends React.Component<{}, {}> {
  render() {
    return (
      <div className="LoanEstimateReceived">
        <AppLayoutContextUpdater
          footerConfig={null}
          appTitle={confirmationText}
          appDocumentTitle={'Loan Estimate Request Received'}
        />
      </div>
    );
  }
}

export default LoanEstimateReceived;
